module.exports = __webpack_public_path__ + "img/whitePappyonLogo.93da475a.png";